import { Component, forwardRef } from '@angular/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from '../../../../Services/CatalogManagement/catalog.service';
import { MacroService } from '../../../../Services/CatalogManagement/macro.service';
import { JobService } from '../../../../Services/job.service';
import { LoginService } from '../../../../Services/login.service';
import { SystemService } from '../../../../Services/system.service';

@Component({
    selector: 'userActionRemoveDeadReferences',
    templateUrl: 'userAction-removeDeadReferences.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRemoveDeadReferences) }
    ],
    standalone: false
})

export class UserActionRemoveDeadReferences extends UserActionBaseComponent {

  removeSelfReferencing: boolean = false;
  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public translate: TranslateService
  ) {
    super(loginService, macroService);
  }

  public createParameterStringAsJsonString(): string {    
    return JSON.stringify({
      removeSelfReferencing: this.removeSelfReferencing      
    });
  
  }

  public parseParameter(parameter: string) {
    
    try {
      const parsed = JSON.parse(parameter);
      this.removeSelfReferencing = parsed.removeSelfReferencing;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
 
  public async canStartMacro(): Promise<boolean> {
        return true;
  }
    
}
